import { render, staticRenderFns } from "./BarChartV2.vue?vue&type=template&id=3e1bb0bd&scoped=true&"
import script from "./BarChartV2.vue?vue&type=script&lang=js&"
export * from "./BarChartV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1bb0bd",
  null
  
)

export default component.exports